import { useEffect, useState } from "react";
import Introduction from "../components/introduction/Introduction";
import AppDownload from "../components/main/app-download/AppDownload";
import MedicalCarousel from "../components/main/medical_carousel/medicalCarousel";
import Questions from "../components/main/questions/Questions";
import Services from "../components/main/services/Services";
import Slider from "../components/main/slider/Slider";
import SocialMedia from "../components/main/socialmedia/SocialMedia";
import MainNewsSection from "../components/main/news/MainNewsSection";
import { MAIN_PAGE } from "../data/texts";
import { ENDPOINTS } from "../api/main-page-endpoints";
import axios from "axios";
import SpecialitiesSection from "../components/main/specialities/SpecialitiesSection";
import DoctorsSwiperSection from "../components/main/doctor-list/DoctorsSwiperSection";
import DoctorsCompactSection from "../components/main/doctor-list/DoctorsCompactSection";

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.2}
    stroke="currentColor"
    className="w-3.5 h-3.5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 4.5 3 12m0 0 7.5 7.5M3 12h18"
    />
  </svg>
);



const MainPage = () => {
  const [data, setData] = useState({
    services: [],
    blogs: [],
    qa: [],
    // mainMenu: [],
    // footerMenu: [],
    specialities: [],
    categories: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const servicesData = MAIN_PAGE.services;
  const aboutUsData = MAIN_PAGE.aboutUs;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
        const [
          servicesRes,
          blogsRes,
          qaRes,
          // mainMenuRes,
          // footerMenuRes,
          specialitiesRes,
          categoriesRes,
        ] = await Promise.all([
          axios.get(ENDPOINTS.SERVICES),
          axios.get(ENDPOINTS.BLOGS),
          axios.get(ENDPOINTS.QA),
          // axios.get(ENDPOINTS.MAIN_MENU),
          // axios.get(ENDPOINTS.FOOTER_MENU),
          axios.get(ENDPOINTS.SPECIALITIES),
          axios.get(ENDPOINTS.CATEGORIES),
        ]);

        setData({
          services: servicesRes.data,
          blogs: blogsRes.data,
          qa: qaRes.data,
          // mainMenu: mainMenuRes.data,
          // footerMenu: footerMenuRes.data,
          specialities: specialitiesRes.data,
          categories: categoriesRes.data,
        });
      } catch (err) {
        console.error("خطا در دریافت اطلاعات:", err);
        setError("خطایی در بارگذاری اطلاعات رخ داده است.");
      } finally {
        console.log("data", data);
        console.log(data.categories.data);
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  if (loading)
    return (
      <div className="w-full h-screen text-center">در حال بارگذاری...</div>
    );
  if (error) return <div className="w-full h-screen text-center">{error}</div>;

  return (
    <div className="font-kalameh md:px-10 ">
      <div className="">
        <div className="flex justify-center">
          <div className="w-full flex flex-col gap-[40px] lg:gap-[60PX]">
            <div className="rounded-3xl lg:-mt-[24px]">
              <Slider specialitiesRes={data.specialities} />
            </div>
            <div className="max-sm:-ml-5 -mt-[28px] lg:-mt-[38px]">
              <SpecialitiesSection categoriesData={data.categories.data} />
            </div>
            <Services
              desc={servicesData.desc}
              servicesData={data.services.data}
            />
            <div className="max-sm:-ml-5">
              <DoctorsSwiperSection />
            </div>
            <div>
              <AppDownload />
            </div>
            <div>
              <MedicalCarousel />
            </div>
             <DoctorsCompactSection />
        <SocialMedia />
        <div className="max-sm:-ml-5">
          <MainNewsSection newsData={data.blogs.data} />

        </div>
        <div className="w-full grid col-auto gap-16">
            <Questions questionsData={data.qa.data} />
          </div>
          </div>
        </div>
       

        

        
        
      </div>
    </div>
  );
};
export default MainPage;
